import cn from "@/v2-ui/utils/utils.cn"
import BaseTabs, { type TabsProps as BaseTabsProps } from "@/v2-ui/tabs"
import { useTabParam } from "./tabs.utils"
import { TabsStateContext, type TabsVariant } from "./tabs.context"

export type TabsProps = Omit<
  BaseTabsProps,
  "value" | "onValueChange" | "orientation"
> & {
  id: string
  defaultValue: string
  isLoading?: boolean
  error?: Error | null | undefined
  isEmpty?: boolean
  emptyLabel?: string
  variant?: TabsVariant
}

function Tabs(props: TabsProps) {
  const {
    id,
    defaultValue,
    isLoading = false,
    error,
    isEmpty = false,
    emptyLabel = "No data available.",
    variant = "default",
    children,
    className,
    ...tabsProps
  } = props

  const [tab, setTab] = useTabParam(id, defaultValue)

  return (
    <TabsStateContext.Provider
      value={{ isLoading, error, isEmpty, emptyLabel, variant }}
    >
      <BaseTabs
        className={cn(
          "ui-tabs",
          variant === "sidebar" && "ui-tabs--sidebar",
          className,
        )}
        onValueChange={setTab}
        value={tab}
        // Vertical orientation gives the sidebar list Radix's up/down roving
        // focus for free; the URL param, triggers and contents are untouched.
        orientation={variant === "sidebar" ? "vertical" : undefined}
        {...tabsProps}
      >
        {children}
      </BaseTabs>
    </TabsStateContext.Provider>
  )
}

export default Tabs
